import React from 'react';

import Error from '../../images/svgs/error.svg';

import { Container, Wrapper, Text, SubText } from './styled';

const ErrorFallback = () => {
  return (
    <Container>
      <Wrapper>
        <img src={Error} alt="error" />
        <Text className="text">Oops! Something went wrong</Text>
        <SubText className="subText">Please refresh the page or try again later</SubText>
      </Wrapper>
    </Container>
  );
};

export default ErrorFallback;
